export class SelectBonusEvents {
    public static readonly SELECT: string = '__SELECT__';
}